fragment PeepRelatedLeadStats on Peep {
    id
    type
    name
    description
    avatarUrl
    phones {
        primary {
            value {
                id
                numberFormatted
            }
        }
    }
    emailAddresses {
        primary {
            value {
                display
            }
        }
    }
    postalAddresses {
        primary {
            value {
                region
            }
        }
    }
    leads {
        stats {
            all {
                ...PeepRelatedLeadStat
            }
        }
    }
    childLeads {
        subsidiaryStats {
            all {
                ...PeepRelatedLeadStat
            }
        }
    }
    ... on Contact {
        jobTitle
    }
}

fragment PeepRelatedLeadStat on LeadStat {
    count
    status
    value {
        formattedValue {
            prefix
            suffix
            formatted
            value
        }
    }
}
